import { ArticleHeaderTheme } from '@/components/ArticleHeader/theme';
import { Link as StandaloneLink } from '@/components/Link';
import { Tag as StandaloneTag } from '@/components/Tag';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: ArticleHeaderTheme });

const Base = $({ as: 'div', slot: 'base' });
const Actions = $({ as: 'div', slot: 'actions' });
const Bylines = $({ as: 'ul', slot: 'bylines' });
const Category = $({ as: 'ul', slot: 'category' });
const Date = $({ as: 'div', slot: 'date' });
const Description = $({ as: 'div', slot: 'description' });
const BylineBio = $({ as: 'p', slot: 'bylineBio' });
const Headline = $({ as: 'h1', slot: 'headline' });
const Media = $({ as: 'div', slot: 'media' });
const Tags = $({ as: 'ul', slot: 'tags' });
const Tag = $({ as: StandaloneTag, theme: ArticleHeaderTheme.Tag });
const ContactUsLink = GenericSlot({ as: StandaloneLink, theme: ArticleHeaderTheme.ContactUsLink });

export const ArticleHeader = Object.assign(Base, {
  Actions,
  Bylines,
  ContactUsLink,
  Date,
  Category,
  Description,
  BylineBio,
  Headline,
  Media,
  Tags,
  Tag,
});
